import { defineMessages } from "react-intl";
const messages = defineMessages({
    reportingDataFrom: {
        id: "aiDiscoverability.reportDateSelector.reportingDataFrom",
        defaultMessage: "Reporting data from",
    },
    latest: {
        id: "aiDiscoverability.reportDateSelector.latest",
        defaultMessage: "Latest",
    },
    past: {
        id: "aiDiscoverability.reportDateSelector.past",
        defaultMessage: "Past",
    },
    inactive: {
        id: "aiDiscoverability.reportDateSelector.inactive",
        defaultMessage: "Inactive",
    },
    readOnlyTooltip: {
        id: "aiDiscoverability.reportDateSelector.readOnlyTooltip",
        defaultMessage: "This overview always shows your latest report — see past reports on the Report page.",
    },
    noReportsYet: {
        id: "aiDiscoverability.reportDateSelector.noReportsYet",
        defaultMessage: "No reports yet",
    },
});
export default messages;
